export const environment = {
  production: true,
  lng: "bg",
  medialng: "bg",
  wsUrl: "wss://app.psiholozite.com/backend/r",
  imageUrl: "https://app.psiholozite.com/backend/",
 
  wbBackendUrl: "https://app.psiholozite.com/backend/",
  contentsBackendUrl:"https://content.daskal.eu/",
  contentsFileMapping: "resources/",
  contentsBackendMediaUrl:"https://video.daskal.eu:444/",
   wbStateSize: 1000000,
   contentModule: true,
      changeInterval: 10000,
   mediawbposter:"a/videojs/audio-poster.png",
  urlPlayer: 'https://wb.daskal.eu/frontend/#/player/',
  extId: "fpfdahkgnebogdleefpikedkogboldbj",
  footerLogo: "assets/images/logo_daskal.png",
  closeRedirection: "https://app.psiholozite.com/view/login.html",
    hbSendInterval: 4000,
  hbCheckInterval: 4000,
  hbCheckThreshold: 4,
  useHb: true, 
  logo: "",
  color: true,
  title:"Психолозите"

};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts